import { ChangeEvent, FC } from 'react';
import { Form } from 'react-bootstrap';
import { getIn } from 'formik';

interface XInputProps {
  label?: string;
  name: string;
  placeholder?: string;
  className?: string;
  type?: string;
  value?: string;
  formik?: any
  disabled?:boolean
  onChange?: (event: ChangeEvent<any>) => void;
}

const XInput: FC<XInputProps> = ({ name, label = name, placeholder = 'Enter', className, type = 'text', value = '', onChange, formik, disabled, ...props }) => {
  const fieldTouched = formik ? getIn(formik.touched, name) : false;
  const fieldError = formik ? getIn(formik.errors, name) : undefined;

  return (
    <Form.Group className={`form-group ${className}`}>
      <Form.Label>{label}</Form.Label>
      <Form.Control
        disabled={disabled}
        {...{
          name,
          type,
          id: name,
          placeholder,
          ...(formik && {
            ...formik.getFieldProps(name),
            isInvalid: fieldTouched && !!fieldError
          }),
          ...(onChange && {
            onChange: (e)=>{
                onChange?.(e);
                if (formik) {
                    formik?.handleChange(e);
                } 
            }
        })
        }}
      />
      {fieldError && (
        <Form.Control.Feedback type="invalid">
          {fieldError}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default XInput;
